// src/components/PrivateRoute.jsx
import { Navigate } from 'react-router-dom';
import { useAuthStatus } from '../hooks/useAuthStatus';
import Spinner from './Spinner';

export default function PrivateRoute({ children }) {
  const { loggedIn, checkingStatus } = useAuthStatus();
  if (checkingStatus) return <Spinner />;
  return loggedIn ? children : <Navigate to="/sign-in" replace />;
}